import { Box, Grid, Typography } from "@mui/material";
import "bootstrap-icons/font/bootstrap-icons.css";
import { exportToExcel } from "./Util";
import { useIsMobile } from "./MobileUtil";

export const TableActions = ({
  fileName,
  data,
  heading,
}: {
  fileName: string;
  data: any;
  heading: string;
}) => {
  const isMobile = useIsMobile();
  return (
    <Box sx={{ display: "flex", marginLeft: "20px", minWidth: "100%", paddingRight: "50px" }}>
      <Grid sx={{ flexGrow: 1 }}>
        <Typography variant={isMobile ? "subtitle2" : "h6"}>{heading}</Typography>
      </Grid>
      <Grid>
        <i
          className="bi bi-file-earmark-excel-fill"
          style={{
            fontSize: "1.5rem",
            color: "green",
          }}
          title="Download as excel"
          onClick={() => exportToExcel(data, fileName)}
        ></i>
      </Grid>
    </Box>
  );
};
